// Prevent Variant Auto-Select Scroll - TSS-012
// Prevents page from scrolling when variant radios are automatically clicked
// Only active when body has TSS-012 class (Intelligems test)

(function() {
  'use strict';

  // Check if TSS-012 class is present
  function isTSS012Active() {
    return document.body.classList.contains('TSS-012');
  }

  // Store original scroll position before any radio clicks
  let savedScrollPosition = null;
  let scrollRestoreTimeout = null;
  let preventScrollUntil = 0;

  function preventVariantScroll() {
    if (!isTSS012Active()) {
      console.log('TSS-012 Scroll Prevention: TSS-012 class not found, skipping');
      return;
    }

    console.log('TSS-012 Scroll Prevention: Active');

    // Prevent browser's automatic scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Aggressively prevent ANY scroll for a period after variant clicks
    window.addEventListener('scroll', function(e) {
      if (Date.now() < preventScrollUntil && savedScrollPosition !== null) {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo(0, savedScrollPosition);
        console.log('TSS-012 Scroll Prevention: Blocked scroll event, keeping at:', savedScrollPosition);
      }
    }, true);

    // Listen for clicks on variant radios (capture phase to catch before other handlers)
    document.addEventListener('click', function(e) {
      const radio = e.target.closest('input[type="radio"][name^="Title"], input[type="radio"][name^="Kit Choice"]');
      
      if (radio) {
        // Save current scroll position before the click
        savedScrollPosition = window.scrollY;
        preventScrollUntil = Date.now() + 500; // Prevent scroll for 500ms
        console.log('TSS-012 Scroll Prevention: User click - saved position:', savedScrollPosition);

        // Clear any existing timeout
        if (scrollRestoreTimeout) {
          clearTimeout(scrollRestoreTimeout);
        }

        // Keep restoring scroll position multiple times to fight aggressive scrolling
        let attempts = 0;
        const maxAttempts = 10;
        const restoreInterval = setInterval(() => {
          if (attempts >= maxAttempts) {
            clearInterval(restoreInterval);
            savedScrollPosition = null;
            preventScrollUntil = 0;
            console.log('TSS-012 Scroll Prevention: Finished monitoring');
            return;
          }
          
          if (window.scrollY !== savedScrollPosition) {
            window.scrollTo(0, savedScrollPosition);
            console.log('TSS-012 Scroll Prevention: Re-restored to:', savedScrollPosition, '(attempt', attempts + 1, ')');
          }
          attempts++;
        }, 50);
      }
    }, true); // Use capture phase

    // Also handle programmatic clicks (like the auto-select scripts)
    const originalClick = HTMLInputElement.prototype.click;
    HTMLInputElement.prototype.click = function() {
      // Check if this is a variant radio
      if (this.type === 'radio' && (this.name.startsWith('Title') || this.name.startsWith('Kit Choice'))) {
        savedScrollPosition = window.scrollY;
        preventScrollUntil = Date.now() + 500; // Prevent scroll for 500ms
        console.log('TSS-012 Scroll Prevention: Programmatic click - saved position:', savedScrollPosition);
        
        // Call original click
        originalClick.call(this);
        
        // Keep restoring scroll position multiple times
        let attempts = 0;
        const maxAttempts = 10;
        const restoreInterval = setInterval(() => {
          if (attempts >= maxAttempts) {
            clearInterval(restoreInterval);
            savedScrollPosition = null;
            preventScrollUntil = 0;
            console.log('TSS-012 Scroll Prevention: Finished monitoring');
            return;
          }
          
          if (window.scrollY !== savedScrollPosition) {
            window.scrollTo(0, savedScrollPosition);
            console.log('TSS-012 Scroll Prevention: Re-restored to:', savedScrollPosition, '(attempt', attempts + 1, ')');
          }
          attempts++;
        }, 50);
      } else {
        // Not a variant radio, just call original
        originalClick.call(this);
      }
    };
  }

  // Wait for TSS-012 class to be added by Intelligems
  function waitForTSS012(retryCount = 0) {
    const maxRetries = 3;
    const timeoutDuration = 10000; // 10 seconds

    console.log('TSS-012 Scroll Prevention: Waiting for TSS-012 class (attempt ' + (retryCount + 1) + ')');

    // Check if class already exists
    if (isTSS012Active()) {
      console.log('TSS-012 Scroll Prevention: TSS-012 class found immediately');
      preventVariantScroll();
      return;
    }

    // Set up MutationObserver to watch for class changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (isTSS012Active()) {
            console.log('TSS-012 Scroll Prevention: TSS-012 class detected via MutationObserver');
            observer.disconnect();
            preventVariantScroll();
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Fallback timeout
    setTimeout(() => {
      observer.disconnect();
      
      if (isTSS012Active()) {
        console.log('TSS-012 Scroll Prevention: TSS-012 class found after timeout');
        preventVariantScroll();
      } else if (retryCount < maxRetries) {
        console.log('TSS-012 Scroll Prevention: Timeout reached, retrying...');
        waitForTSS012(retryCount + 1);
      } else {
        console.log('TSS-012 Scroll Prevention: Max retries reached, TSS-012 class not found - not activating');
      }
    }, timeoutDuration);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForTSS012);
  } else {
    waitForTSS012();
  }

  // Handle page restoration from bfcache (back/forward navigation)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && isTSS012Active()) {
      console.log('TSS-012 Scroll Prevention: Page restored from bfcache, re-activating');
      preventVariantScroll();
    }
  });

})();
